<div class="wrapper">
  <div class="heading text-type-5">{{ data.quantity }} {{ displayName || data?.type }}</div>
  <div class="time text-type-14 mt-[10px]">
    {{ data.duration }} hour{{ data.duration !== 1 ? 's' : '' }}
  </div>
  @if (displayMatched) {
    <div class="matched text-type-14 mt-[10px]">{{ matchedNo }} {{ matchedNo > 1 ? 'occurrences' : 'occurrence' }}</div>
  }
</div>
